export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_SIZE_NO_PSSF = 60;

export const DEFAULT_FILTER_LIMIT = 10;
export const DEFAULT_SEARCH_LIMIT = 250;
export const MAX_TAG_CHARACTERS = 30;

export const DEFAULT_DROPDOWN_PAGE_SIZE = 10;
export const LARGE_DROPDOWN_PAGE_SIZE = 50;
export const DEFAULT_DROPDOWN_PAGE_SIZE_NO_PAGINATION = 1000;

export enum DEAL_REGION_SCOPE {
  Worldwide = 'Worldwide',
  WorldExcludingChina = 'World excluding China',
  NorthAmerica = 'North America',
  USAndCanada = 'U.S. and Canada',
  USOnly = 'U.S. only',
}

export const DEAL_REGION_SCOPES_OPTIONS = [
  {
    i18nKey: 'worldwide',
    value: DEAL_REGION_SCOPE.Worldwide,
  },
  {
    i18nKey: 'worldExcludingChina',
    value: DEAL_REGION_SCOPE.WorldExcludingChina,
  },
  {
    i18nKey: 'northAmerica',
    value: DEAL_REGION_SCOPE.NorthAmerica,
  },
  {
    i18nKey: 'usAndCanada',
    value: DEAL_REGION_SCOPE.USAndCanada,
  },
  {
    i18nKey: 'usOnly',
    value: DEAL_REGION_SCOPE.USOnly,
  },
];

export enum ENABLED_AUTO_DBOM {
  Enabled = 'enabled',
  Disabled = 'disabled',
  Inherit = 'inheritFromParent',
}

export const ENABLED_AUTO_DBOM_OPTIONS = [
  { i18nKey: 'enabled', value: ENABLED_AUTO_DBOM.Enabled },
  { i18nKey: 'disabled', value: ENABLED_AUTO_DBOM.Disabled },
  { i18nKey: 'inheritFromParent', value: ENABLED_AUTO_DBOM.Inherit },
];
